<script>
import NotificationWidget from '@/components/header/NotificationWidget.vue'
import CountBadge from '@/components/ui/CountBadge.vue'
import { handleResponseError } from '@/utils/toastUtils'
import { useNotificationStore } from '@/store/notificationStore'

export default {
  name: 'NotificationBell',
  components: { CountBadge, NotificationWidget },
  data() {
    return {
      notificationStore: useNotificationStore()
    }
  },
  async created() {
    await this.getNotificationCount()
  },
  methods: {
    async getNotificationCount() {
      try {
        await this.notificationStore.fetchNotificationCount()
      } catch (error) {
        handleResponseError(error)
      }
    }
  }
}
</script>

<template>
  <v-menu location="bottom right" offset="4" :close-on-content-click="false">
    <template v-slot:activator="{ props, isActive }">
      <v-btn-icon
        v-bind="props"
        class="nav-btn notification-button"
        icon="mdi-bell-outline"
        :color="isActive ? 'primary' : 'black'"
        variant="tonal"
      >
        <v-icon icon="mdi-bell-outline" />
        <CountBadge
          v-if="notificationStore.notificationCount > 0"
          class="notification-count"
          :count="notificationStore.notificationCount"
          color="warning"
        />
      </v-btn-icon>
    </template>

    <NotificationWidget />
  </v-menu>
</template>

<style scoped>
.notification-button {
  position: relative;
}

.notification-count {
  background: color-mix(in srgb, rgb(var(--v-theme-warning)) 14%, white);
  color: rgb(var(--v-theme-warning));
  position: absolute;
  right: -8px;
  top: -8px;
  z-index: 1;
}
</style>
